import React from 'react'

export function RefreshIcon(
  color = '#007B39',
  secondaryColor = '#E1FEE6',
  width = 70,
  height = 50
) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 70 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.875" cy="16.875" r="1.875" fill={color} />
      <circle cx="65.625" cy="38.125" r="1.875" fill={color} />
      <circle cx="8.125" cy="11.875" r="0.625" fill={color} />
      <circle cx="6.25" cy="28.75" r="1.25" fill={color} />
      <circle cx="63.125" cy="45.625" r="0.625" fill={color} />
      <circle cx="68.75" cy="28.75" r="1.25" fill={color} />
      <rect x="11.25" width={50} height={50} rx={25} fill={secondaryColor} />
      <g clipPath="url(#clip0_5191_9643)">
        <path
          d="M44.25 29L48.25 28L49.25 32"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.25 28C47.3617 30.5172 45.7481 32.7152 43.6126 34.3168C41.4771 35.9184 38.9153 36.852 36.25 37C33.7862 37.0004 31.382 36.2425 29.364 34.8291C27.3459 33.4158 25.8118 31.4155 24.97 29.1M28.25 21L24.25 22L23.25 18"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.25 22C25.93 17.4 31.09 13 36.25 13C38.7258 13.007 41.1388 13.7795 43.1583 15.2118C45.1777 16.644 46.7047 18.6658 47.53 21"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5191_9643">
          <rect
            width={28}
            height={28}
            fill="white"
            transform="translate(22.25 11)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
